export default "__VITE_ASSET__8562755f__"